import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useAppController, setDarkMode } from 'context';

const getInitialMode = () => {
    const stored = localStorage.getItem('hg-dark-mode');
    if (stored === null) return 'auto';
    return stored === 'true' ? 'dark' : 'light';
};

const ThemeToggle = () => {
    const [, dispatch] = useAppController();
    const [mode, setMode] = React.useState(getInitialMode);

    const cycle = () => {
        const next =
            mode === 'auto' ? 'light' : mode === 'light' ? 'dark' : 'auto';
        if (next === 'auto') {
            localStorage.removeItem('hg-dark-mode');
            setDarkMode(
                dispatch,
                window.matchMedia('(prefers-color-scheme: dark)').matches
            );
        } else {
            localStorage.setItem('hg-dark-mode', String(next === 'dark'));
            setDarkMode(dispatch, next === 'dark');
        }
        setMode(next);
    };

    // Thumb: w-4 for light/dark, expands to w-[36px] for auto (44px container - 4px each side)
    const thumbWidth = mode === 'auto' ? 'w-[36px]' : 'w-4';
    const thumbTranslate = mode === 'dark' ? 'translate-x-6' : 'translate-x-1';

    return (
        <button
            onClick={cycle}
            title={`Theme: ${mode}`}
            className="group relative inline-flex h-6 w-[44px] shrink-0 cursor-pointer items-center rounded-full bg-muted shadow-[inset_0_1px_1px_rgba(0,0,0,0.1)] transition-colors dark:bg-muted/75"
        >
            {/* Sun icon — visible in light mode */}
            <Sun
                className={`absolute right-1.5 h-3 w-3 text-muted-foreground transition-opacity duration-200 group-hover:text-accent ${mode === 'light' ? 'opacity-100' : 'opacity-0'}`}
            />
            {/* Moon icon — visible in dark mode */}
            <Moon
                className={`absolute left-1.5 h-3 w-3 text-muted-foreground transition-opacity duration-200 group-hover:text-accent ${mode === 'dark' ? 'opacity-100' : 'opacity-0'}`}
            />

            {/* Sliding thumb — expands for auto */}
            <span
                className={`pointer-events-none flex h-4 items-center justify-center rounded-full bg-card shadow-sm shadow-slate-300 ring-0 transition-all duration-200 dark:shadow-slate-900 ${thumbWidth} ${thumbTranslate}`}
            >
                <span
                    className={`overflow-hidden text-[10px] font-semibold leading-none text-muted-foreground transition-all duration-200 ${mode === 'auto' ? 'w-auto opacity-100' : 'w-0 opacity-0'}`}
                >
                    Auto
                </span>
            </span>
        </button>
    );
};

export default ThemeToggle;
